import { z } from "zod";
import type { AvtalePeriodeDto } from "@/api/generated";
import { formatDateStringInterval } from "@/utils";
import type { BestillingPeriode } from "../context";

export const periodeSchema = z.object({
  selectedPeriode: z
    .string()
    .min(1, { error: "pages.periode.form.paaakrevd" })
    .refine((v) => v !== "", { error: "pages.periode.form.paaakrevd" }),
});

export type PeriodeSchema = z.infer<typeof periodeSchema>;

/**
 * AvtalePeriode mappers to map between API, schema and bestillingContext models
 */
export class AvtalePeriodeSchemaMapper {
  static toBestillingPeriode = (schema: PeriodeSchema): BestillingPeriode => {
    const [from, to] = schema.selectedPeriode.split(";");
    return {
      fromInclusive: from,
      toExclusive: to,
    };
  };

  static toPeriodeSchema = (
    contextData: BestillingPeriode | null,
  ): PeriodeSchema | undefined => {
    if (contextData == null) return undefined;
    return {
      selectedPeriode: `${contextData.fromInclusive};${contextData.toExclusive}`,
    };
  };

  static toSelectOptionValue = (dto: AvtalePeriodeDto): string => {
    return `${dto.fromInclusive};${dto.toExclusive}`;
  };

  static toSelectOptionLabel = (dto: AvtalePeriodeDto): string => {
    return formatDateStringInterval(
      dto.fromInclusive,
      dto.toExclusive,
      true,
      false,
      "long",
    );
  };
}
